import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import {Row, Col, Alert, Modal} from 'react-bootstrap';
import Loader from '../../../../Loader';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';

import DinasJatim_1 from './DinasJatim_1';
import DinasJatim_2 from './DinasJatim_2';
import DinasJatim_3_4 from './DinasJatim_3_4';
import DinasJatim_5_6 from './DinasJatim_5_6';

import Footer from './components/Footer';

import { Typography, Grid } from '@material-ui/core';

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPay: false,
        }
    }

    headerRender(){
        return(
            <Grid 
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={6}>
                <Grid item xs={12}>
                    <div style={{background : 'rgb(30 49 99 / 30%)'}}>
                        <div className="warna-header-utama">

                        </div>
                    </div>
                    <div style={{marginTop: '-108px', margin: '-147px 0px 0px 20px'}}>
                        <table width="100%">
                            <tr>
                                <td><img src="/image/dinas/logo-jawa-timur.png" width="115px" /></td>
                                <td width="70%">
                                    <b className="text-putih1">BENCHMARKING COMPREHENSIVE</b> <br />
                                    <b className="text-putih2">ACADEMIC GENERAL CHECK UP (C`AGCU)</b> <br />
                                    <b className="text-putih3">DINAS PENDIDIKAN PROVINSI JAWA TIMUR</b>
                                </td>
                                <td><img src="/image/dinas/logo-agcu-putih.png" width="145px" /></td>
                            </tr>
                        </table>
                    </div>
                </Grid>
            </Grid>
        )
    }

    render() { 
        const {} = this.state;
        return (
            <div className="container-fluid" style={{paddingBottom: '50px'}}>
                {/* HEADER */}
                {/* {this.headerRender()} */}
                
                <DinasJatim_1 />
                <div className="pagebreak" ></div>
                <DinasJatim_2 />
                <div className="pagebreak" ></div> 
                <DinasJatim_3_4 />
                <div className="pagebreak" ></div> 

                <DinasJatim_5_6 />


                <div id="btn_print">                        
                    <div className="fixed_button">
                        <button className="btn btn-outline-primary  pull-right" title="Print Report" style={{marginRight:'1em'}} onClick={() => window.print()}>
                            <li className="fa fa-print"></li>
                        </button>
                    </div>     
                </div> 
            </div>
        );
    }


}
 
export default index;